import React from 'react'
import { Typography } from '@material-ui/core'
import { CampaignType } from '../../../../constants/marketingCampaign'
import { CampaignDefinition } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { Menu } from '../../MarketingCampaigns.promo.services'
import { getOffersFromConfig, getProductDetailsFromConfig } from '../../../../utils/product'
import { normalizeShopIds } from '../../CampaignModalSkeleton/CampaignModalSkeleton.helpers'
import { ProductDiscountThresholdRuleState } from './types'
import { validateProductDiscountThresholdRule } from './validate'
import { buildProductDiscountThresholdFormValues } from './buildFormValues'
import { ProductDiscountThresholdRuleStep } from './RuleStep.view'
import { ProductDiscountThresholdConfirmationSummary } from './ConfirmationSummary.view'

const ruleDescription = (
	<Typography variant="body2" style={{ color: '#616161', marginBottom: 14, lineHeight: 1.65 }}>
		Définissez une <strong style={{ color: '#212121' }}>réduction en pourcentage</strong> sur une
		sélection de <strong style={{ color: '#212121' }}>produits</strong>, lorsque le panier du client
		atteint le <strong style={{ color: '#212121' }}>montant minimum</strong>.
	</Typography>
)

function getInitialRuleFromCampaign(
	campaign: any,
	menus: Menu,
): ProductDiscountThresholdRuleState {
	const ids = normalizeShopIds(campaign.shopIds)
	const sid = ids[0]
	const offers =
		sid && campaign.config?.products
			? getOffersFromConfig(menus, campaign.config.products, sid)
			: []
	const choosed =
		sid && campaign.config?.products
			? getProductDetailsFromConfig(menus, campaign.config.products, sid, true)
			: []
	return {
		discount: campaign.config?.discount?.value ?? null,
		threshold: campaign.config?.threshold ?? null,
		products: campaign.config?.products || [],
		purchasedProducts: choosed,
		selectedProducts: offers,
		disabledPurshasedProducts: [],
	}
}

export const productDiscountAfterThresholdDefinition: CampaignDefinition<ProductDiscountThresholdRuleState> =
	{
		type: CampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD,
		RuleStep: ProductDiscountThresholdRuleStep,
		ConfirmationSummary: ProductDiscountThresholdConfirmationSummary,
		defaultRule: {
			discount: null,
			threshold: null,
			products: [],
			purchasedProducts: [],
			selectedProducts: [],
			disabledPurshasedProducts: [],
		},
		validateRule: validateProductDiscountThresholdRule,
		buildFormValues: buildProductDiscountThresholdFormValues,
		ruleDescription,
		getInitialRuleFromCampaign,
		confirmationLimitPolicy: 'required',
		showOrderTypesInConfirmation: true,
		forceDeliveryOrderType: false,
		allowsPermanent: true,
	}
